import type {BusinessPoolAccount} from '@/types';
import {
  AfriexCountryCode,
  AfriexCurrencyCode,
  AfriexTransactionChannel,
} from '@/types';
import {countryCodeToCurrencyCodeMap} from '@/utils/countryCodeToCurrencyCodeMap';

export class BusinessPoolAccountValidator {
  constructor(private request: Partial<BusinessPoolAccount>) {}

  private throwErrorMessage(errorMessage: string): never {
    throw new Error(errorMessage);
  }

  private validateName() {
    if (!this.request?.accountName) {
      this.throwErrorMessage('No account name provided');
    }
    return this;
  }

  private validateAccountNumber() {
    if (!this.request?.accountNumber) {
      this.throwErrorMessage('No account number provided');
    }
  }

  private validateCountryCode() {
    if (!this.request?.countryCode) {
      this.throwErrorMessage('No country selected');
    }
    if (!Object.values(AfriexCountryCode).includes(this.request?.countryCode)) {
      this.throwErrorMessage('Invalid country code provided');
    }
  }

  private validateCurrencyCode() {
    if (!this.request?.currencyCode) {
      this.throwErrorMessage('No currency selected');
    }
    if (
      !Object.values(AfriexCurrencyCode).includes(this.request?.currencyCode)
    ) {
      this.throwErrorMessage('Invalid currency code provided');
    }
  }

  private validateChannel() {
    if (!this.request?.channel) {
      this.throwErrorMessage('No channel selected');
    }
    if (
      !Object.values(AfriexTransactionChannel).includes(this.request?.channel)
    ) {
      this.throwErrorMessage('Invalid channel provided');
    }
  }

  private validateInstitutionName() {
    if (!this.request?.institutionName) {
      this.throwErrorMessage('No bank or operator name provided');
    }
  }

  private validate() {
    this.validateAccountNumber();
    this.validateCountryCode();
    this.validateCurrencyCode();
    this.validateChannel();
    this.validateInstitutionName();
    this.validateName();
  }

  value(): BusinessPoolAccount {
    this.request = {
      ...this.request,
      currencyCode:
        countryCodeToCurrencyCodeMap?.[
          this.request?.countryCode as AfriexCountryCode
        ],
    };
    this.validate();
    return this.request as BusinessPoolAccount;
  }
}
